'use strict';

var UnmatchedCompetitorsFareQuickFilterController = function UnmatchedCompetitorsFareQuickFilterController($scope) {
  $scope.modalOpen = false;
  $scope.toggleModal = function () {
    $scope.modalOpen = !$scope.modalOpen;
  };
  $scope.closeModal = function () {
    $scope.onResetClick();
    $scope.modalOpen = false;
  };
  $scope.updateFilter = function () {
    $scope.updateCallBack();
    $scope.modalOpen = false;
  };
  $scope.onResetClick = function () {
    $scope.filter.display = 'lowestCompFares';
    $scope.filter.stops = 'all';
  };
  $scope.$on('competitor-fare-chart:resetQuickFilter', $scope.onResetClick);
};
UnmatchedCompetitorsFareQuickFilterController.$inject = ['$scope'];
module.exports = UnmatchedCompetitorsFareQuickFilterController;